import React from 'react';
import {withRouter} from "react-router";
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'

class RewardGroupSwitchComponent extends React.Component {

    onSelectionChange(rewardFriendlyName) {
            this.props.history.push('/'+rewardFriendlyName);
    }

    render() {
        const options = this.props.switchOptions.map(option => {return {value: option.friendlyName, label: option.description}});

        let selectedOption = this.findSelectedOption(options);

        return <div className="grouped-reward-select">
            <h1>{this.props.groupSwitchTitle}</h1>
            <Dropdown options={options} onChange={(option) => {this.onSelectionChange(option.value)}} value={selectedOption} placeholder="Select an option" />
        </div>;
    }

    findSelectedOption(options) {
        let selectedSwitchOption = this.props.switchOptions.filter(s => s.rewardId === this.props.selectedRewardId);
        let selectedOption = selectedSwitchOption.length === 0 ? null : options.filter(option => option.value === selectedSwitchOption[0].friendlyName)[0];
        return selectedOption;
    }
}

export default withRouter(RewardGroupSwitchComponent);